import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No verification token provided");
      return;
    }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(() => {
        setStatus("success");
        setMessage("Your email has been verified! You now have unlimited access.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-pink-50 flex items-center justify-center p-4" data-testid="verify-email-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Card className="p-8 text-center">
          {status === "verifying" && (
            <>
              <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center animate-spin border-4 border-orange-500 border-t-transparent"></div>
              <h2 className="text-2xl font-bold mb-2">Verifying...</h2>
              <p className="text-slate-600">Please wait while we verify your email</p>
            </>
          )}
          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold mb-2 text-green-600">Email Verified!</h2>
              <p className="text-slate-600 mb-6">{message}</p>
              <Button onClick={() => navigate("/dashboard")} className="btn-primary w-full" data-testid="go-to-dashboard-btn">
                Continue to Dashboard
              </Button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold mb-2 text-red-600">Verification Failed</h2>
              <p className="text-slate-600 mb-6">{message}</p>
              <Button onClick={() => navigate("/")} className="btn-primary w-full" data-testid="verify-back-home-btn">
                Back to Home
              </Button>
            </>
          )}
        </Card>
      </motion.div>
    </div>
  );
}
